// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { NgxLoggerLevel } from "ngx-logger";



//var apiUrl = "https://localhost:54008";
//var webUrl = "https://localhost:54008";

//var apiUrl = "https://localhost:8456";
//var webUrl = "https://localhost:8456";

var apiUrl = "https://ghs.osha.gov.tw/hazcom";
var webUrl = "https://ghs.osha.gov.tw/hazcom";

//var apiUrl = "https://ghs.demo-pro2e.com/HAZCOM";
//var webUrl = "https://ghs.demo-pro2e.com/HAZCOM";



export const environment = {
  production: true,
  mode: 'PROD',
  logging: {
    serverLoggingUrl: apiUrl + '/api/log/LogMsg',
    level: NgxLoggerLevel.ERROR,
    serverLogLevel: NgxLoggerLevel.ERROR,
  },
  urls: {
    apiEndpoint: apiUrl,
    webUrl: webUrl,
    prefix:'api/'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
